// extracted by mini-css-extract-plugin
export default {"wrapper":"pbbePA2cwv6bcyJ96EBn","text":"vB8OlPH6hX_iBNUO1qUQ"};